import { createElement } from 'react';
import { Button } from '@alifd/next';
import './index.scss';
const OadpEntityButtonBatchDelete = function OadpEntityButtonBatchDelete({ name, id, entity, tableComponentRefId, label, type, size, text, disabled, style, onClick, __designMode, ...otherProps }) {
    if (__designMode === 'design') {
        onClick = (e) => {
            console.log('design mode OadpEntityButtonBatchDelete click');
        };
    }
    return (createElement(Button, Object.assign({ type: type, size: size, disabled: disabled, text: text, style: style, onClick: onClick }, otherProps), label));
};
export default OadpEntityButtonBatchDelete;
